<template>
  <div class="MobileGeneral">
    <div class="mobile-header">
      <b-button class="BtnRegister" @click="modalHeight">
        <b-icon-plus
          scale="1.5"
          style="
            width: 30px;
            background: #006458;
            height: 30px;
            color: white;
            border-radius: 2px;
          "
        ></b-icon-plus>
        <span style="width: 170px">Nova Nota de Compra</span>
      </b-button>
    </div>

    <transition name="slide-fade">
      <div v-if="showFilters" class="mobile-filters-container">
        <div class="filter-row">
          <label>Período:</label>
          <div class="date-group">
            <input type="date" v-model="startDate" />
            <span class="date-separator">até</span>
            <input type="date" v-model="endDate" />
          </div>
        </div>

        <div class="filter-row">
          <b-form-select
            v-model="type"
            :options="filterCombobox"
            size="sm"
            class="mobile-select"
          ></b-form-select>
        </div>

        <div class="filter-row search-row">
          <b-input
            v-model="textPesquisa"
            placeholder="Buscar..."
            class="mobile-search-input"
            @keyup.enter="filterPerMonth(page)"
          ></b-input>
          <b-button @click="filterPerMonth(page)" class="btn-search-mobile">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
    </transition>

    <div class="status-scroll-container">
      <div class="status-card draft">
        <span class="status-label"> Produtos</span>
        <span class="status-count">{{ this.countProducts }}</span>
      </div>
      <div class="status-card finalized">
        <span class="status-label">Importadas</span>

        <span class="status-count">{{ this.importedPurchases }}</span>
      </div>
      <div class="status-card canceled">
        <span class="status-label">Total</span>
        <span class="status-count">
          {{
            this.sumPurchase.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</span
        >
      </div>
    </div>
    <div class="header-actions">
      <b-button class="btn-toggle-filters" @click="showFilters = !showFilters">
        <b-icon-funnel-fill></b-icon-funnel-fill>
      </b-button>
    </div>
    <div class="card-list-container">
      <div
        v-for="dataPurchase in dataPurchases"
        :key="dataPurchase.id"
        class="sale-card"
        @click="findIdByEdit(dataPurchase.id)"
      >
        <div class="card-header-mobile">
          <span class="receipt-id">#{{ dataPurchase.numeroNfe }}</span>
          <span class="receipt-date">{{ dataPurchase.data | moment }}</span>
          <span class="status-indicator"></span>
        </div>

        <div class="card-body-mobile">
          <div class="info-group">
            <label>Cliente :</label>
            <strong>{{
              dataPurchase.razaoSocial || "CONSUMIDOR FINAL"
            }}</strong>
          </div>
          <div class="info-group">
            <label>Valor :</label>
            <span>
              {{
                (
                  dataPurchase.valorNfe || dataPurchase.valorTotal
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span
            >
          </div>
        </div>

        <div class="card-actions-mobile">
          <b-button
            variant="link"
            class="action-btn"
            @click.stop="openModalDeletePurchase(dataPurchase.id)"
          >
            <b-icon-trash></b-icon-trash> Excluir
          </b-button>
        </div>
      </div>

      <div v-if="!dataPurchases.length" class="empty-state">
        <b-icon-inbox scale="2"></b-icon-inbox>
        <p>Nenhuma compra encontrada.</p>
      </div>
    </div>

    <div class="mobile-pagination">
      <b-button
        class="mobile-pagination-btn"
        :disabled="page == 1"
        @click="previousPage(page)"
      >
        Anterior
      </b-button>

      <span class="mobile-pagination-current">Página {{ page }}</span>

      <b-button
        class="mobile-pagination-btn"
        :disabled="this.dataLength < 9"
        @click="nextPage(page)"
      >
        Próxima
      </b-button>
    </div>

    <b-modal
      id="modal-center2"
      hide-footer
      hide-header
      centered
      size="lg"
      title="Detalhes"
    >
      <div>
        <h6 class="titleModal">Detalhes da movimentação</h6>
        <div class="contentModal">
          <span> <b-icon-truck></b-icon-truck> Dados Fornecedor</span>
          <div class="rowModal">
            <div class="input-group-supplier">
              <input
                disabled
                class="input borderInput"
                v-model="this.dataSupplier.nomeFantasia"
              />
              <label class="user-label"> Nome Fantasia </label>
            </div>
            <div class="input-group-supplier">
              <input
                disabled
                class="input borderInput"
                v-model="this.dataSupplier.cpfCnpj"
              />
              <label class="user-label"> CNPJ </label>
            </div>
          </div>
        </div>
        <div class="contentModal">
          <span> <b-icon-file-text></b-icon-file-text> Dados da NF-e</span>
          <div class="rowModal">
            <div class="input-group">
              <input
                disabled
                type="date"
                class="input borderInput"
                v-model="this.dataDetails.dataCompra"
              />
              <label class="user-label"> Data da Compra </label>
            </div>
            <div class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="this.dataDetails.numeroNfe"
              />
              <label class="user-label"> N° NF-e </label>
            </div>
            <div class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="this.dataDetails.modeloNfe"
              />
              <label class="user-label"> Modelo </label>
            </div>
            <div class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="this.dataDetails.serieNfe"
              />
              <label class="user-label"> Série </label>
            </div>
            <div class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="this.dataDetails.valorNfe"
              />
              <label class="user-label"> Valor nota </label>
            </div>
          </div>
          <div class="rowModal">
            <div class="input-group-key">
              <b-form-input
                ref="chaveNfeInput"
                disabled
                class="input borderInput"
                v-model="dataDetails.chaveNfe"
              />
              <label class="user-label"> Chave da NF-e </label>
            </div>
            <button
              class="iconCopy"
              style="border: none"
              @click="copyChaveNfeToClipboard"
            >
              <b-icon-stickies scale="1" class="mr-1"></b-icon-stickies>
              Copiar
            </button>
          </div>
        </div>
        <div class="contentModal">
          <span> <b-icon-box-seam></b-icon-box-seam> Itens Importados </span>
          <div class="ContentTableModal">
            <table style="width: 100%">
              <thead
                style="
                  color: whitesmoke;
                  background: #3a4750;
                  text-align: center;
                  height: 29px;
                "
              >
                <tr style="width: 100%">
                  <th>Nome</th>
                  <th>Quantidade</th>
                  <th>Valor</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="product in returnProducts"
                  style="text-align: center; height: 28px"
                  :key="product.id"
                >
                  <td>{{ product.nome }}</td>
                  <td>{{ product.quantidade }}</td>
                  <td>
                    {{
                      product.valorUnitario.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td>
                    {{
                      (
                        product.valorUnitario * product.quantidade
                      ).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="btnModal">
          <button @click="redirectSefaz" class="btnContent">
            Ir para a Sefaz
          </button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center2')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>
    <ModalConfirm
      modalName="modal-confirm-delete-purchase"
      title="Deseja excluir a compra?"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="deleteAll"
      leftButtonText="Não, obrigado!"
      rightButtonText="Sim, quero excluir!"
    />
    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalPurchase" @click="modalHeight">
          Fechar
        </b-button>
        <CreatePurchaseMobile
          style="margin-top: 30px"
          :payloadFromDfe="payloadFromDfe"
          @clearPayloadByDfe="clearPayloadByDfe"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { DateTime } from "luxon";
import ServicePurchase from "../../services/servicePurchase";
import serviceProductsPurchase from "../../services/serviceProductsPurchase";
import CreatePurchaseMobile from "./CreatePurchaseMobile.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import api from "../../services/axios";
import moment from "moment";

export default {
  components: {
    CreatePurchaseMobile,
    ModalConfirm,
  },
  data() {
    return {
      year: DateTime.local().year,
      month: DateTime.local(),
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      monthSelected: "",
      yearSelected: "",
      colapseModal: false,
      spinDelete: false,
      isAdvancedSearch: false,
      modalContainer: "contentModalDisable",
      idPurchaseFromModal: null,
      page: 1,
      dataLength: 0,
      sumPurchase: 0,
      countProducts: 0,
      importedPurchases: 0,
      dataPurchases: {},
      dataDetails: {},
      returnProducts: [],
      dataSupplier: {},
      dataSumPurchase: {},
      filterCombobox: [
        { value: "razaoSocial", text: "Fornecedor" },
        { value: "numeroNfe", text: "NF-e" },
        { value: "", text: "Selecione..." },
      ],
      payloadFromDfe: {
        xml: "",
        cfop: "",
        fromDfe: false,
      },
      filterMonth: [
        { value: "1", text: "Janeiro" },
        { value: "2", text: "Fevereiro" },
        { value: "3", text: "Março" },
        { value: "4", text: "Abril" },
        { value: "5", text: "Maio" },
        { value: "6", text: "Junho" },
        { value: "7", text: "Julho" },
        { value: "8", text: "Agosto" },
        { value: "9", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" },
      ],
      filterYear: [
        { value: "2021", text: "2021" },
        { value: "2022", text: "2022" },
        { value: "2023", text: "2023" },
        { value: "2024", text: "2024" },
        { value: "2025", text: "2025" },
        { value: "2026", text: "2026" },
        { value: "2027", text: "2027" },
        { value: "2028", text: "2028" },
        { value: "2029", text: "2029" },
        { value: "2030", text: "2030" },
        { value: "2031", text: "2031" },
        { value: "2032", text: "2032" },
      ],
      showFilters: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "SET_DATA_SEARCH_FROM_PURCHASE",
      "SET_DEFAULT_TYPE_PURCHASE",
      "ALTER_TYPE_PURCHASE",
    ]),

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";
      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_PURCHASE({});
        this.SET_DEFAULT_TYPE_PURCHASE();
      }
      await this.filterPerMonth();
      this.filterPerMonth();
    },

    async enableAdvancedSearch() {
      this.isAdvancedSearch = !this.isAdvancedSearch;
      if (!this.isAdvancedSearch) {
        this.startDate = "";
        this.endDate = "";
      }
    },

    handleModals(name) {
      this.ALTER_TYPE_PURCHASE(name);

      this.modalHeight();
    },

    openPurchaseAndAssignXmlDFe(payloadDfe) {
      this.payloadFromDfe = payloadDfe;
      this.ALTER_TYPE_PURCHASE("purchase");
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
    },

    async filterPurchase(page) {
      try {
        const data = await ServicePurchase.searchPurchase(
          this.textPesquisa,
          this.type,
          page,
          this.startDate,
          this.endDate
        );
        this.dataLength = data.data.length;
        this.dataPurchase = data.data;
        this.clearSearch();
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao listar as compras",
          type: "info",
        });
      }
    },

    monthHasChanged() {
      this.month = this.month.set({ month: parseInt(this.monthSelected) });
      this.year = this.yearSelected;
      this.filterPerMonth();
    },

    async filterPerMonth() {
      try {
        if (this.startDate && this.endDate) {
          const start = DateTime.fromISO(this.startDate);
          const end = DateTime.fromISO(this.endDate);
          const diffInMonths = end.diff(start, "months").months;

          if (diffInMonths > 6) {
            this.$toast.open({
              message:
                "Atenção! Período superior a 6 meses.Para esse intervalo, utilize o módulo Relatórios.",
              type: "info",
            });
            return;
          }

          if (end < start) {
            this.$toast.open({
              message: "A data final não pode ser anterior à data inicial",
              type: "warning",
            });
            return;
          }
        }

        const { data } = await api.get(
          `/purchase/per/month/search?month=${this.month.month}&year=${
            this.year
          }&q=${encodeURIComponent(this.textPesquisa)}&type=${this.type}&page=${
            this.page
          }&startDate=${this.startDate}&endDate=${this.endDate}`
        );
        const purchase = data?.data ?? [];
        this.dataPurchases = purchase.purchaseTotal;
        this.dataLength = data.data.purchaseTotal.length;
        this.dataSumPurchase = purchase.purchaseTotal;
        this.countProducts = purchase.totals.totalItems;
        this.sumPurchase = purchase.totals.totalValue;
        this.importedPurchases = purchase.totals.importedPurchases;
      } catch (error) {
        console.log(error);
      }
    },

    getTotal(dataPurchase) {
      return dataPurchase.reduce(
        (total, purchase) => total + purchase.valorTotal,
        0
      );
    },

    async findIdByEdit(id) {
      const data = await ServicePurchase.findPurchaseById(id);
      data.products = await serviceProductsPurchase.getProductsForGrid(
        id
      );
      this.handleEditPurchase(data);
    },

    handleEditPurchase(dataPurchase) {
      this.SET_DATA_SEARCH_FROM_PURCHASE(dataPurchase);
      this.handleModals("purchase");
    },

    openModalDeletePurchase(id) {
      this.idPurchaseFromModal = id;
      this.$bvModal.show("modal-confirm-delete-purchase");
    },

    async deleteAll() {
      this.spinDelete = true;
      try {
        await serviceProductsPurchase.deleteAll(this.idPurchaseFromModal);

        this.$bvModal.hide("modal-confirm-delete-purchase");
        this.filterPerMonth(1);
        this.filterPerMonth();

        return this.$toast.open({
          message: "Deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: `${error.response}`,
            type: "error",
          });
      } finally {
        this.spinDelete = false;
      }
    },

    async editPurchase(id) {
      try {
        const data = await ServicePurchase.findPurchaseById(id);
        this.$emit("editPurchase", data);
        this.$root.$emit("bv::toggle::collapse", "accordion-dadosCadastrais");
        this.$emit("alterTabIndex", this.tabIndex);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else
          this.$toast.open({
            message: "Ocorreu um erro ao ler informações",
            type: "info",
          });
      }
    },

    async redirectSefaz() {
      try {
        window.open(
          "https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&tipoConteudo=7PhJ+gAVw2g=",
          "_blank"
        );
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao redirecionar para a página",
          type: "info",
        });
      }
    },

    copyChaveNfeToClipboard() {
      const inputElement = this.$refs.chaveNfeInput;
      try {
        navigator.clipboard.writeText(inputElement.value);
        this.$toast.open({
          message: "Chave da NF-e copiada para a área de transferência.",
          type: "success",
        });
      } catch (err) {
        this.$toast.open({
          message: "Não foi possível copiar a chave da NF-e.",
          type: "info",
        });
      }
    },

    async updateMonth(direction) {
      if (direction === "prev") {
        this.month = this.month.minus({ months: 1 });
        this.year = this.yearSelected;
        this.monthSelected = this.month.month;
      } else if (direction === "next") {
        this.month = this.month.plus({ months: 1 });
        this.year = this.yearSelected;
        this.monthSelected = this.month.month;
      }

      await this.filterPerMonth();
    },

    nextPage() {
      this.filterPerMonth((this.page += 1));
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterPerMonth((this.page -= 1));
      }
    },

    clearPayloadByDfe() {
      this.payloadFromDfe = {
        xml: "",
        cfop: "",
        fromDfe: false,
      };
    },
  },

  async mounted() {
    this.monthSelected = this.month.month;
    this.yearSelected = this.year;

    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();

    await this.filterPerMonth();
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
    }),
  },
  async created() {
    this.ALTER_SIZE_MODAL("disable");
    this.SET_DATA_SEARCH_FROM_PURCHASE({});
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  beforeDestroy() {
    this.ALTER_SIZE_MODAL("disable");
  },
};
</script>

<style scoped>
.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 0px;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  width: 100%;
  background: #ffff;
  transition: all 0.7s ease-in-out;
}
.closeModalPurchase {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 42%;
  z-index: 900;
  font-size: 10px;
  height: 30px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 0 0 20px 20px;
  color: rgb(6, 6, 6);
}

.closeModalPurchase:hover {
  background: whitesmoke;
  color: red;
}

.closeModalPurchase:focus {
  background: red;
  border: none;
  box-shadow: none;
}
.disable {
  position: absolute;
  width: 100%;
  height: 0;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}
.MobileGeneral {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 50%, #f8fafc 100%);
  padding-bottom: 80px;
  font-family: 'Poppins', sans-serif;
  position: relative;
}

.MobileGeneral::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 20% 50%, rgba(0, 98, 86, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(64, 184, 131, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 40% 80%, rgba(0, 98, 86, 0.03) 0%, transparent 50%);
  pointer-events: none;
  z-index: -1;
}

.mobile-header {
  padding: 20px 15px 45px 15px;
  width: 100%;
  position: relative;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  color: white;
  transition: all 0.5s ease;
  background: linear-gradient(135deg, #006256 0%, #40b883 50%, #006256 100%);
  background-size: 200% 200%;
  animation: gradientShift 8s ease infinite;
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.mobile-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  animation: shimmer 3s infinite;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.BtnRegister {
  width: 180px;
  height: 40px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  color: #006458;
  border: none;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.BtnRegister .b-icon {
  width: 24px !important;
  height: 24px !important;
  background: #006458 !important;
  color: white !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 12px !important;
}

.BtnRegister span {
  width: auto !important;
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0.3px;
}

.BtnRegister::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.BtnRegister:hover::before {
  left: 100%;
}

.BtnRegister:hover {
  background: rgba(255, 255, 255, 1);
  color: #006458;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.BtnRegister:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.header-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
}

.btn-toggle-filters {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  color: #006458;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 12px;
  width: 36px;
  height: 36px;
  padding: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.btn-toggle-filters::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.btn-toggle-filters:hover::before {
  left: 100%;
}

.btn-toggle-filters:hover {
  background: linear-gradient(135deg, #006256, #40b883);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 98, 86, 0.25);
}

.btn-toggle-filters:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(0, 98, 86, 0.2);
}

.mobile-filters-container {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  padding: 20px 15px 25px 15px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.12);
  border-radius: 20px 20px 0 0;
  backdrop-filter: blur(20px);
}

.filter-row {
  margin-bottom: 12px;
}

.filter-row label {
  font-size: 12px;
  color: #374151;
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.date-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-group input {
  flex: 1;
  font-size: 13px;
  padding: 10px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
}

.date-group input:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.date-separator {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.mobile-select {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  font-size: 13px;
}

.mobile-select:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.search-row {
  display: flex;
  gap: 8px;
  margin-bottom: 0;
}

.mobile-search-input {
  flex: 1;
  border-radius: 8px;
  height: 40px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  padding: 10px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  font-size: 13px;
}

.mobile-search-input:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.btn-search-mobile {
  background: linear-gradient(135deg, #006458, #40b883);
  border: none;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  box-shadow: 0 3px 10px rgba(0, 100, 88, 0.3);
  transition: all 0.3s ease;
}

.btn-search-mobile:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(0, 100, 88, 0.4);
}

.status-scroll-container {
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  padding: 0 15px;
  position: relative;
  margin-top: -30px;
  gap: 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.status-scroll-container::-webkit-scrollbar {
  display: none;
}
.status-card-text {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}
.status-card {
  min-width: 85px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  padding: 12px 8px;
  border-radius: 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.status-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #40b883, #006256);
  border-radius: 12px 12px 0 0;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.1);
}

.status-card.draft::before {
  background: linear-gradient(90deg, #94a3b8, #64748b);
}

.status-card.finalized::before {
  background: linear-gradient(90deg, #22c55e, #16a34a);
}

.status-card.canceled::before {
  background: linear-gradient(90deg, #ef4444, #dc2626);
}

.status-card.draft .status-label {
  color: #64748b;
  font-weight: 600;
}

.status-card.finalized .status-label {
  color: #16a34a;
  font-weight: 600;
}

.status-card.canceled .status-label {
  color: #dc2626;
  font-weight: 600;
}

.status-label {
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 4px;
  text-align: center;
}

.status-count {
  font-size: 18px;
  font-weight: 800;
  color: #1a202c;
  font-family: 'Poppins', sans-serif;
  background: linear-gradient(135deg, #006256, #40b883);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.card-list-container {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sale-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  border-radius: 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  padding: 15px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.sale-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #40b883, #006256);
  border-radius: 0 12px 12px 0;
}

.sale-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.1);
  border-color: rgba(0, 98, 86, 0.2);
}

.sale-card:active {
  transform: translateY(-1px);
  border-color: #006458;
  box-shadow: 0 4px 12px rgba(0, 98, 86, 0.15);
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 98, 86, 0.1);
}

.receipt-id {
  font-weight: 800;
  color: #006458;
  font-size: 16px;
  background: linear-gradient(135deg, #006256, #40b883);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.receipt-date {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  background: rgba(0, 98, 86, 0.1);
  padding: 3px 8px;
  border-radius: 12px;
  font-family: 'Poppins', sans-serif;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #40b883, #006256);
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 184, 131, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(64, 184, 131, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 184, 131, 0);
  }
}

.info-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
}

.info-group label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  margin: 0 !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.info-group strong {
  font-size: 14px;
  color: #1a202c;
  font-weight: 700;
  font-family: 'Poppins', sans-serif;
}

.info-group span {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.card-actions-mobile {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid rgba(0, 98, 86, 0.1);
  margin-top: 12px;
  padding-top: 12px;
  gap: 8px;
}

.action-btn {
  font-size: 11px;
  color: #006458;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 15px;
  background: rgba(0, 98, 86, 0.1);
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-btn:hover {
  color: white;
  background: linear-gradient(135deg, #006256, #40b883);
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 98, 86, 0.3);
}

@media (max-width: 420px) {
  .mobile-pagination {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.mobile-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 15px 8px;
}

.mobile-pagination-btn {
  min-width: 92px;
  border-radius: 10px;
  border: 1px solid #d9e1e7;
  background: #fff;
  color: #006256;
  font-weight: 600;
  font-size: 13px;
}

.mobile-pagination-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mobile-pagination-current {
  color: #334155;
  font-size: 13px;
  font-weight: 600;
}

.fab-add {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #006458;
  color: white;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 100, 88, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  transition: transform 0.2s;
}

.fab-add:active {
  transform: scale(0.95);
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8fffe 0%, #ffffff 100%);
  border-radius: 16px;
  margin: 15px;
  border: 2px dashed rgba(0, 98, 86, 0.2);
}

.empty-state .b-icon {
  color: rgba(0, 98, 86, 0.3);
  margin-bottom: 12px;
}

.empty-state p {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  font-family: 'Poppins', sans-serif;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>